import React, { PureComponent, ReactNode } from "react";
import "./ThreeOptionSlider.css";

interface Props {
  checkedOpt: 0 | 1 | 2 | 3;
  // FIXME: using 0|1|2|3 options as if I'd re-use this abstractly was silly
  onChangeOption: (sliderId: string, num: 0 | 1 | 2 | 3) => void;
  sliderId: string; // some metadata to let the callback tell us what changed
  isPin: boolean;
  isPinManual: boolean;
}
interface State {}

const UNCHECKED_ICON = "☐";
const INCLUDED_ICON = "☑";
const EXCLUDED_ICON = "☒";
const ACCIDENT_ICON = "☑"; // there isn't a good icon for this, really [♮]";
const MANUAL_ICON = "■";

class ThreeOptionSlider extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  handleChange = (changeEvent: React.ChangeEvent<HTMLInputElement>) => {
    // "controlled input" - but when transitioning from unchecked to checked, the actual checkbox is "checked"
    // in this moment before the parent state is updated, flows down, and really checks it.
    const { sliderId, checkedOpt, isPinManual } = this.props;
    const boxClicked = parseInt(changeEvent.target.value) as 0 | 1 | 2 | 3;

    if (checkedOpt === boxClicked && !isPinManual) {
      // first, let the user force-pin.  If they intended to unpin, likely they'd click another box
      this.props.onChangeOption(sliderId, checkedOpt);
    } else {
      this.props.onChangeOption(sliderId, changeEvent.target.checked ? boxClicked : 0);
    }
  };

  chooseEnableIcon = () => {
    const { checkedOpt, isPinManual } = this.props;
    if (checkedOpt !== 1) return UNCHECKED_ICON;
    if (isPinManual) return MANUAL_ICON;
    return INCLUDED_ICON;
  };

  chooseDisableIcon = () => {
    const { checkedOpt, isPinManual } = this.props;
    if (checkedOpt !== 2) return UNCHECKED_ICON;
    if (isPinManual) return MANUAL_ICON;
    return EXCLUDED_ICON;
  };

  chooseAccidentIcon = () => {
    const { checkedOpt, isPinManual } = this.props;
    if (checkedOpt !== 3) return UNCHECKED_ICON;
    if (isPinManual) return MANUAL_ICON;
    return ACCIDENT_ICON;
  };

  render(): ReactNode {
    const { checkedOpt, sliderId, isPin, isPinManual } = this.props;

    const isPinCss = isPin ? "setting-is-pinned" : "";
    const isManualCss = isPinManual ? "setting-is-manual" : "";

    const mainClass = `note-pin-opts ${isPinCss} ${isManualCss}`;
    /**
     * FIXME: this is a massive pile of crap.
     * You had a good notion about abstracting the slider apart from these 3 specific options..
     * but the execution was poor.
     */
    return (
      <label className={mainClass}>
        <input
          className="note-pin-opts-opt"
          type="checkbox"
          name={sliderId}
          id={sliderId + "opt1"}
          value="1"
          checked={checkedOpt === 1}
          onChange={this.handleChange}
        ></input>
        <label className="slider-option1-label" htmlFor={sliderId + "opt1"}>
          <span className="note-pin-opts-opt-detail" title="In Scale">
            {this.chooseEnableIcon()}
          </span>
        </label>
        <input
          className="note-pin-opts-opt"
          type="checkbox"
          name={sliderId}
          id={sliderId + "opt2"}
          value="2"
          checked={checkedOpt === 2}
          onChange={this.handleChange}
        ></input>
        <label className="slider-option2-label" htmlFor={sliderId + "opt2"}>
          <span className="note-pin-opts-opt-detail" title="Never In Scale">
            {this.chooseDisableIcon()}
          </span>
        </label>
        <input
          className="note-pin-opts-opt"
          type="checkbox"
          name={sliderId}
          id={sliderId + "opt3"}
          value="3"
          checked={checkedOpt === 3}
          onChange={this.handleChange}
        ></input>
        <label className="slider-option3-label" htmlFor={sliderId + "opt3"}>
          <span className="note-pin-opts-opt-detail" title="Accidental">
            {this.chooseAccidentIcon()}
          </span>
        </label>
      </label>
    );
  }
}

export default ThreeOptionSlider;
